/**
 * Floating
 *
 * @selector [data-js-floating]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';
import AnimationFrame from '../../../lib/animation/AnimationFrame.js';
import mediaDispatcher from '../../plugins/mediaDispatcher.js';

//Todo use fastdom for measure & mutate

const DEFAULT_OPTIONS = {
    deviceMin: false,
    deviceMax: false,
    maxShift: 10, // in percent
};

export default class Floating extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        this.$window = window;

        this.options = $.extend({}, DEFAULT_OPTIONS, this.$el.data('js-floating'));

        if (this.options.lerp == null) {
            this.options.lerp = Math.random() * 0.075 + 0.05;
        }

        if (this.options.deviceMin || this.options.deviceMax) {
            mediaDispatcher
                .isOrAbove(this.options.deviceMin)
                .then(() => {
                    this.enable();
                })
                .otherwise(() => {
                    this.disable();
                });
        } else {
            this.enable();
        }

        return this;
    }

    enable() {
        this.isPaused = false;
        this.progress = 0;

        this.recalculate();

        this.bindListeners();

        this.render();
    }

    disable() {
        this.off();
        this.isPaused = true;

        setTimeout(() => {
            this.el.style.transform = undefined;
            this.el.style.willChange = undefined;
        }, 0);
    }

    bindListeners() {
        this.on(window, 'scroll', this.onScroll);
        this.on(window, 'debouncedResize', this.onWindowResize);
    }

    onScroll() {
        this.calcScroll();
    }

    onWindowResize() {
        this.recalculate();
        this.render();
    }

    recalculate() {
        const rect = this.el.getBoundingClientRect();

        this.windowHeight = this.$window.outerHeight;

        this.calcScroll();

        this.y = rect.top + this.scrollTop + this.el.offsetHeight / 2;
    }

    calcScroll() {
        this.scrollTop = this.$window.scrollY;
        this.scrollBottom = this.scrollTop + this.windowHeight;
    }

    render() {
        if (this.scrollBottom > this.y && this.scrollTop < this.y) {
            let progress = (this.scrollBottom - this.y) / this.windowHeight;
            this.progress += (progress - this.progress) * this.options.lerp;

            this.progress = Math.min(1, Math.max(0, this.progress));

            if (this.progress !== this.renderedProgress) {
                fastdom.mutate(() => this.paint());
            }
        }

        if (!this.isPaused) {
            AnimationFrame.request(() => {
                this.render();
            });
        }
    }

    paint() {
        this.el.style.transform = `translateY(${(this.progress - 0.5) * (this.options.maxShift * 2)}%)`;
        this.el.style.willChange = 'transform';

        this.renderedProgress = this.progress;
    }
}
